// ─────────────────────────────────────────────────────────────────────────
// "Who took this quiz" table — shared by the course owner's per-topic Quiz
// results panel (src/views/course.js) and a bound teacher's per-course
// aggregate view (src/views/teaching.js). Both ultimately read from the
// same users/{uid}/courses/{courseId}/topics/{topicId}/quizTakers records
// (see functions/schoolMarketplace.js recordSchoolSubscriptionQuizScore) —
// one topic-scoped (lib/quizScore.js getTopicQuizTakers), one aggregated
// across a whole course (functions/schools.js getBoundCourseQuizResults),
// which is the only difference `showTopic` accounts for.
// ─────────────────────────────────────────────────────────────────────────

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

// `takers` — array of { studentUid, studentEmail, score, maxScore, createdAt,
// schoolName, topicTitle? }. `emptyMessage` shown when the array is empty.
export function renderQuizTakersTable(container, takers, { showTopic = false, emptyMessage = 'No one has taken this quiz yet.' } = {}) {
  if (!takers || takers.length === 0) {
    container.innerHTML = `<p style="color:var(--text-dim);font-size:0.86rem;">${escapeHtml(emptyMessage)}</p>`;
    return;
  }
  container.innerHTML = `<div style="overflow:auto;max-height:360px;"><table class="admin-table">
    <thead style="position:sticky;top:0;background:var(--surface);"><tr>
      <th>Student</th>
      ${showTopic ? '<th>Topic</th>' : ''}
      <th>School</th>
      <th>When</th>
      <th style="text-align:right;">Score</th>
    </tr></thead>
    <tbody>
      ${takers.map((t) => {
        const pct = t.maxScore > 0 ? Math.round((t.score / t.maxScore) * 100) : 0;
        return `<tr>
          <td>${escapeHtml(t.studentEmail || t.studentUid || 'Unknown')}</td>
          ${showTopic ? `<td>${escapeHtml(t.topicTitle || '')}</td>` : ''}
          <td>${escapeHtml(t.schoolName || '')}</td>
          <td>${t.createdAt ? new Date(t.createdAt).toLocaleString() : ''}</td>
          <td style="text-align:right;font-weight:700;">${t.score}/${t.maxScore} (${pct}%)</td>
        </tr>`;
      }).join('')}
    </tbody>
  </table></div>`;
}
